import { render, staticRenderFns } from "./mentor-comment.vue?vue&type=template&id=caa67644&lang=pug"
import script from "./mentor-comment.vue?vue&type=script&lang=js"
export * from "./mentor-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports